export default __webpack_public_path__ + "static/media/c.080009f9.png";